module.exports = __webpack_public_path__ + "img/sophia.d3bae143.jpg";